import request from '@/utils/request'
import Resource from '@/apis/resource'
class CursosVidasResource extends Resource {
  constructor() {
    super('api/cursosVidas')
  }
  fetchCursosVidas() {
    return request({
      url: 'https://sir.diresacajamarca.gob.pe:8050/' + this.uri,
      method: 'get'
    })
  }
}
export { CursosVidasResource as default }